export function initializeBackToTop() {
  const button = document.querySelector('.back-to-top');
  if (!button) return;

  let updateScheduled = false;

  const updateVisibility = () => {
    button.classList.toggle('show', window.scrollY > 300);
    updateScheduled = false;
  };

  const scheduleUpdate = () => {
    if (updateScheduled) return;

    updateScheduled = true;
    window.requestAnimationFrame(updateVisibility);
  };

  updateVisibility();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
}
